import React, { useMemo } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { interactions } from 'styles'

import { usePageContext } from 'contexts/Page'

import { Box, Button } from 'components'
import { Footer } from '../../Footer'
import { Card } from 'components/Card'
import MakerCTA from 'components/Ctas/MakerCTA'

const Root = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const Widgets = styled(Box)`
  display: grid;
`

const Widget = styled(Card)`
  ${interactions};
`

export const TutorialNavigation = React.memo(() => {
  const { currentStepNum, maxStepNum, tutorial } = usePageContext()

  const nextStep = useMemo(() => tutorial?.steps?.[currentStepNum], [
    currentStepNum,
    tutorial,
  ])
  const previousStep = useMemo(() => tutorial?.steps?.[currentStepNum - 2], [
    currentStepNum,
    tutorial,
  ])

  return (
    <>
      <Root>
        {currentStepNum === 1 ? (
          <div />
        ) : (
          <Button
            backgroundColor="white"
            shadowColor="lavender"
            color="primary"
            label={previousStep?.meta?.title}
            onClick={() => navigate(`${tutorial.uri}${currentStepNum - 1}`)}
          />
        )}
        {currentStepNum === maxStepNum ? (
          <div />
        ) : (
          <Button
            backgroundColor="text"
            shadowColor="primary"
            label={`${nextStep?.meta?.title}`}
            onClick={() => navigate(`${tutorial.uri}${currentStepNum + 1}`)}
          />
        )}
      </Root>
      <Widgets marginY={6} paddingX={4}>
        <Widget interaction="bumpRaised">
          <MakerCTA />
        </Widget>
      </Widgets>
      <Footer />
    </>
  )
})
